import { render, staticRenderFns } from "./EmployerClaims.vue?vue&type=template&id=d86b53e4"
import script from "./EmployerClaims.vue?vue&type=script&lang=js"
export * from "./EmployerClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports